import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import KeyboardArrowLeftRounded from '@mui/icons-material/KeyboardArrowLeftRounded'
import { makeStyles } from '@mui/styles'
import { Box, Grid, Paper, Theme } from '@mui/material'

import { Tag } from '@3m5/sm_publish-frontend-api'
import { PostingTemplate } from '@professocial/professocialTypes/types/commonTypes'
import ButtonComponent from '@professocial/professocialFormComponents/FormComponents/ButtonComponent'
import SelectTagComponent from '@professocial/professocialFormComponents/FormComponents/SelectTagComponent'

import { getTags } from '../../../../store/posting/posting.selector'
import { PostingScreen } from '../../../types/types'
import {
  createTagsInitiated, getAllTagsInitiated,
} from '../../../../store/posting/posting.actions'
import { CreateTagsRequest } from '@3m5/sm_publish-frontend-api'

interface IProps {
  posting: PostingTemplate
  changePosting?: (post: PostingTemplate) => void
  changePostingScreen?: (value: PostingScreen) => void
}

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    marginTop: '10px',
    padding: '25px 30px',
  },
  button: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body1.fontSize,
    textTransform: 'initial',
    marginRight: '20px',
  },
}))

const Tags: React.FC<IProps> = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const dispatchGetTags = useCallback(() => dispatch(getAllTagsInitiated()), [dispatch])
  const dispatchCreateTags = useCallback((params: CreateTagsRequest) => dispatch(createTagsInitiated(params)), [dispatch])

  const storedTags: Tag[] | undefined = useSelector(getTags)

  const [posting, setPosting] = useState<PostingTemplate>(props.posting)
  const [tagData, setTagData] = useState<Tag[]>([])
  const [temporaryTags, setTemporaryTags] = useState<Tag[]>([])

  const savePosting = (tags: Tag[]) => {
    const post: PostingTemplate = {
      ...posting,
      tags: tags,
    }
    setPosting(post)
    props.changePostingScreen && props.changePostingScreen(PostingScreen.MAIN)
    props.changePosting && props.changePosting(post)
  }

  const changeTags = () => {
    // prüfen ob neue Tags dabei sind und ggf. in TagData integrieren
    const tempNewTags: string[] = []
    temporaryTags.forEach((tag: Tag) => {
      if (!tag.id) {
        tempNewTags.push(tag.label)
      }
    })
    if (tempNewTags.length === 0) {
      savePosting(temporaryTags)
    } else {
      dispatchCreateTags({ requestBody: tempNewTags })
    }
  }

  const setTagDropdown = () => {
    if (storedTags) {
      setTagData(storedTags)
      if (temporaryTags.length !== 0) {
        const newTags: Tag[] = []
        // hier noch die neuen Tag an das Posting setzen
        temporaryTags.forEach((temp: Tag) => {
          if (temp.id) {
            newTags.push(temp)
          } else {
            const fullTag: Tag | undefined = storedTags.find((elem:Tag) => elem.label === temp.label)
            fullTag && newTags.push(fullTag)
          }
        })
        savePosting(newTags)
        // temporäre Daten zurücksetzen
        setTemporaryTags([])
      }
    }
  }

  useEffect(() => {
    setTagDropdown()
  }, [],
  )

  useEffect(() => {
    if (storedTags) {
      setTagDropdown()
    } else {
      dispatchGetTags()
    }
  }, [storedTags],
  )

  useEffect(() => {
    props.posting && setPosting(props.posting)
  }, [props.posting],
  )

  return (
    <>
      <ButtonComponent
        className={classes.button}
        startIcon={<KeyboardArrowLeftRounded />}
        variant='text'
        color='info'
        text={t('postingCommon:disable')}
        onClick={() => props.changePostingScreen && props.changePostingScreen(PostingScreen.MAIN)}
      />
      <Grid container>
        <Grid xs={12} item>
          <Paper className={classes.paper}>
            <SelectTagComponent
              options={tagData}
              label={t('postingCommon:tags')}
              size='small'
              value={posting.tags}
              placeholder={t('postingCommon:choose')}
              onChange={(options: Tag[]) => {
                setTemporaryTags(options)
              }}
            />
            <Box component='div' style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', marginTop: '10px' }}>
              <ButtonComponent
                text={t('postingCommon:save')}
                onClick={() => {
                  changeTags()
                }}
              />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </>
  )
}

export default Tags
